import { configureUnhandledErrorsNotification, reportErrorToSentry } from '@vtblife/layout-components/shell/utils';

import { Foquz, type FoquzOnError } from '@vtblife/foquz';

import { configureSentry } from '../services/sentry';
import { configureBusEventsNotification } from '../services/notification-event-handler';
import { RootClientData } from '../services/notification-event-handler/utils';
import { configureBrowserStorage } from '../services/storage';
import { checkCSSRules } from '../services/check-css-rules';

export function bootstrapBrowserEnvironment(
    environment: string | undefined,
    extra?: Record<string, any>,
    displayToasterErrorNotification?: boolean,
) {
    const rootClientData = new RootClientData(extra?.userStore?.deviceIp);

    checkCSSRules();
    configureBrowserStorage();
    configureSentry(environment, extra);
    configureUnhandledErrorsNotification(rootClientData, extra, displayToasterErrorNotification);
    configureBusEventsNotification(rootClientData);
    const onFoquzError: FoquzOnError = (error, { eventName, phase }) => {
        reportErrorToSentry({
            error,
            level: 'warning',
            description: `Foquz widget triggerEvent failed (phase=${phase}, eventName=${eventName})`,
            tags: { source: 'foquz', foquzPhase: phase, foquzEventName: eventName },
            fingerprint: ['foquz-widget-trigger-error', phase, eventName],
        });
    };

    Foquz.getInstance().configureBridge({ onError: onFoquzError });
}
